import type { ReactNode } from 'react';

/**
 * `contain` centres a cutout inside the white slot (padded).
 * `fill` makes the image cover the whole slot edge to edge.
 */
export type ImageCardModalFit = 'contain' | 'fill';

export const DEFAULT_IMAGE_CARD_MODAL_FIT: ImageCardModalFit = 'contain';

export type ImageCardModalProps = {
  /** Anything that renders inside the fixed-height white image slot. */
  image: ReactNode;
  imageFit?: ImageCardModalFit;
  title: ReactNode;
  subtitle?: ReactNode;
  actions: ReactNode;
  onClose: () => void;
};
